var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 21.051 25.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.011,12.768C.011,10.233-.013,7.698.024,5.163c.014-.96.376-1.848.918-2.646C1.868,1.154,3.127.303,4.774.061c.661-.097,1.313-.073,1.976.037,1.138.188,2.051.788,2.941,1.46.769.581,1.554,1.141,2.331,1.711,1.034.759,2.068,1.517,3.102,2.277.849.624,1.701,1.245,2.544,1.877.583.437,1.193.849,1.722,1.346.898.843,1.401,1.915,1.589,3.135.243,1.573-.133,2.999-1.045,4.284-.444.625-1.064,1.074-1.675,1.524-1.171.863-2.343,1.725-3.518,2.583-1.214.886-2.434,1.766-3.649,2.651-.759.553-1.505,1.123-2.274,1.662-.709.498-1.501.811-2.363.926-1.642.219-3.121-.189-4.398-1.237-.922-.757-1.566-1.73-1.869-2.885-.138-.525-.174-1.089-.178-1.636C-.008,17.439.003,15.104.003,12.768c.003,0,.006,0,.008,0ZM3.215,12.78c0,2.443-.015,4.887.008,7.33.008.806.435,1.437,1.102,1.866.968.622,1.934.54,2.854-.128.708-.513,1.406-1.04,2.112-1.556,1.036-.756,2.076-1.506,3.112-2.263,1.048-.766,2.096-1.531,3.136-2.308.569-.425,1.151-.841,1.671-1.321.759-.702.801-2.042.302-2.875-.302-.505-.778-.809-1.229-1.143-.959-.71-1.927-1.407-2.888-2.114-.921-.677-1.838-1.361-2.759-2.039-1.112-.819-2.23-1.629-3.335-2.457-.5-.375-1.057-.6-1.669-.59-.586.01-1.128.2-1.592.607-.496.436-.809.969-.816,1.611-.024,2.46-.01,4.92-.01,7.38Z",
    fill: "currentColor"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRun);
export default __webpack_public_path__ + "static/media/Run.299e413e.svg";
export { ForwardRef as ReactComponent };